import { z } from "zod"

const activitySearchSchema = z.object({
  action: z.string().optional(),
  actor_id: z.string().optional(),
})

type ActivitySearch = z.infer<typeof activitySearchSchema>

export { activitySearchSchema }
export type { ActivitySearch }
